<a class="ga-event" routerLink="/drag-pak-experience" data-dest="Drag Pak" data-ga_category="Home" data-ga_action="Click" data-ga_label="Drag Pak Tile">
  <div class="cta-content">
    <div class="title">Drag Pak</div>
    <div class="description">Inside the 2021 Dodge Challenger Mopar Drag Pak</div>
  </div>
</a>
